import { QUERY_PARAM_REDIRECT_TO, QUERY_PARAM_LOCALE } from '@yoweb/utils/constants/queryParams';
import { API_PATH } from '@yoweb/utils/constants/routes';
import { QUERY_ONBOARDING_TASK_ID } from './queryParams';
export var URL_FAQ_PAGE = function URL_FAQ_PAGE(baseStoreURL) {
  return "".concat(baseStoreURL, "/faq");
};
export var URL_HOW_IT_WORKS_PAGE = function URL_HOW_IT_WORKS_PAGE(baseStoreURL) {
  return "".concat(baseStoreURL, "/how-it-works");
};
export var URL_TUTORIAL_LANDING_PAGE = function URL_TUTORIAL_LANDING_PAGE(baseStoreURL) {
  return "".concat(baseStoreURL, "/lp/tutorial");
};
export var URL_PRICING_PAGE = function URL_PRICING_PAGE(baseStoreURL) {
  return "".concat(baseStoreURL, "/pricing");
};
/* @deprecated Use URL_CHECKOUT_PLAN_DIRECT instead since redirect to login is automatic with auth guard */

export var URL_CHECKOUT_PLAN = function URL_CHECKOUT_PLAN(baseStoreURL, language) {
  return "".concat(baseStoreURL).concat(API_PATH, "/login?").concat(QUERY_PARAM_REDIRECT_TO, "=/checkout/plan&").concat(QUERY_PARAM_LOCALE, "=").concat(language);
};
export var URL_CHECKOUT_PLAN_DIRECT = function URL_CHECKOUT_PLAN_DIRECT(baseStoreURL) {
  return "".concat(baseStoreURL, "/checkout/plan");
};
export var URL_CHECKOUT_ONBOARDING = function URL_CHECKOUT_ONBOARDING(baseStoreURL, language, onboardingTaskId) {
  var redirectUrl = '/checkout/onboarding' + (onboardingTaskId ? "?".concat(QUERY_ONBOARDING_TASK_ID, "=").concat(onboardingTaskId) : '');
  return "".concat(baseStoreURL).concat(API_PATH, "/login?").concat(QUERY_PARAM_REDIRECT_TO, "=").concat(encodeURI(redirectUrl), "&").concat(QUERY_PARAM_LOCALE, "=").concat(language);
};
export var URL_PROPOSALS_FAQ_LINK = function URL_PROPOSALS_FAQ_LINK(baseStoreURL) {
  return "".concat(baseStoreURL, "/faq?question=specialist-purchases");
};
export var URL_RESERVATION_FAQ_LINK = function URL_RESERVATION_FAQ_LINK(baseStoreURL) {
  return "".concat(baseStoreURL, "/faq?question=make-reservations");
};
export var URL_FAQ_CANCEL_QUESTION = function URL_FAQ_CANCEL_QUESTION(baseStoreURL) {
  return "".concat(baseStoreURL, "/faq?question=cancel");
};
export var URL_FAQ_PAUSE_QUESTION = function URL_FAQ_PAUSE_QUESTION(baseStoreURL) {
  return "".concat(baseStoreURL, "/faq?question=pause");
};
export var URL_FAQ_WHEN_ARE_CHARGED_QUESTION = function URL_FAQ_WHEN_ARE_CHARGED_QUESTION(baseStoreURL) {
  return "".concat(baseStoreURL, "/faq?question=when-are-charged");
};
export var URL_FAQ_BILLING_PURCHASES = function URL_FAQ_BILLING_PURCHASES(baseStoreURL) {
  return "".concat(baseStoreURL, "/faq?section=billing-purchases");
};
export var URL_FAQ_BILLING = function URL_FAQ_BILLING(baseStoreURL) {
  return "".concat(baseStoreURL, "/faq?section=billing");
};
export var URL_YO_PRIVACY_POLICY = function URL_YO_PRIVACY_POLICY(baseStoreURL) {
  return "".concat(baseStoreURL, "/privacy-policy");
};
export var URL_YO_COOKIE_POLICY = function URL_YO_COOKIE_POLICY(baseStoreURL) {
  return "".concat(baseStoreURL, "/cookie-policy");
};
export var URL_YO_TERMS_OF_SERVICE = function URL_YO_TERMS_OF_SERVICE(baseStoreURL) {
  return "".concat(baseStoreURL, "/terms-of-service");
};
export var URL_YO_DISCLAIMERS = function URL_YO_DISCLAIMERS(baseStoreURL) {
  return "".concat(baseStoreURL, "/disclaimers");
}; // Only for ja-JP

export var URL_YO_SPECIFIED_COMMERCIAL_TRANSACTIONS = function URL_YO_SPECIFIED_COMMERCIAL_TRANSACTIONS(baseStoreURL) {
  return "".concat(baseStoreURL, "/specified-commercial-transactions");
};
export var URL_YO_PRIME_PRO_TERMS_OF_SERVICE = function URL_YO_PRIME_PRO_TERMS_OF_SERVICE(baseStoreURL) {
  return "".concat(baseStoreURL, "/primepro-terms-of-service");
};
export var URL_TERMS_JAPAN_ADDENDUM_EMBED = 'https://www.yohana.jp/embed/terms-of-service#japan-provisions';
export var URL_PRIVACY_JAPAN_ADDENDUM_EMBED = 'https://www.yohana.jp/embed/privacy-policy#japan-residence';
export var GOOGLE_AUTH_URL = 'https://accounts.google.com/o/oauth2/v2/auth';
export var NYLAS_API_URL = 'https://api.us.nylas.com';